import { ProgressSpinner } from "primereact/progressspinner";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import PermissionGate from "../permissions/PermissionGate";

const PrivateRoutes = () => {
  const { loading, token } = useSelector((state) => state.AuthReducer);

  return (
    <>
      {loading && (
        <div className="flex justify-center items-center z-50 w-screen h-full fixed top-0 left-0 bg-white bg-opacity-50 ">
          <ProgressSpinner />
        </div>
      )}

      {token ? (
        <PermissionGate>
          <Outlet />
        </PermissionGate>
      ) : (
        <Navigate to="/" />
      )}
    </>
  );
};

export default PrivateRoutes;
